import { Button, Center, Container, Loader, Table } from "@mantine/core";
import { useEffect, useState } from "react";
import { Link, useLocation } from "wouter";
import { getStyles } from "../../api";
import TagGroup from "../../_Common/TagGroup";
import { IconCheck, IconCross, IconX } from "@tabler/icons-react";

export default function AdminStyleList() {
  const [data, setData] = useState(null);
  const [, setLocation] = useLocation();

  useEffect(() => {
    getStyles().then((data) => {
      setData(data);
    });
  }, []);

  if (!data)
    return (
      <Center>
        <Loader mt="xl" size="xl" />
      </Center>
    );

  return (
    <Container>
      <Button component={Link} to="styles/new">
        Add Style
      </Button>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Title</Table.Th>
            <Table.Th>Alias</Table.Th>
            <Table.Th>Public</Table.Th>
            <Table.Th>Prompt</Table.Th>
            <Table.Th>Tags</Table.Th>
            <Table.Th>Loras</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.map((p) => (
            <Table.Tr key={p.id} onClick={() => setLocation(`styles/${p.id}`)}>
              <Table.Td>{p.title}</Table.Td>
              <Table.Td>{p.alias}</Table.Td>
              <Table.Td>{p.isPublic ? <IconCheck /> : <IconX /> }</Table.Td>
              <Table.Td>{p.prompt ? <IconCheck /> : <IconX /> }</Table.Td>
              <Table.Td><TagGroup size="xs" tags={p.tags} /></Table.Td>
              <Table.Td>{p.loras.length}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Container>
  );
}
